import { Dialog } from "@headlessui/react";
import DialogBackdrop from "./DialogBackdrop";
import { useTranslation } from "react-i18next";

export default function PDFDialog({
  title,
  description,
  pdfSource,
  dialogState,
  setDialogState,
}) {
  const { t } = useTranslation();
  function isBase64(str) {
    if (str === "" || str.trim() === "") {
      return false;
    }
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }
  return (
    <Dialog
      open={dialogState}
      onClose={() => setDialogState(false)}
      className="ui-dialogs"
    >
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <DialogBackdrop />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className={`ui-default-dialog ${
            isBase64(pdfSource) ? "w-4/5 h-[90%]" : ""
          } `}
        >
          <Dialog.Title className="font-body text-xl font-bold text-left">
            {title}
          </Dialog.Title>
          <button
            className="ui-default-dialog-close"
            aria-label="close manage notification preferences window"
            onClick={() => setDialogState(false)}
          >
            <svg
              className="ui-icon h-3.5 w-3.5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>
          <hr />
          <Dialog.Description>{description}</Dialog.Description>

          {!isBase64(pdfSource) ? (
            <p>
              {t("AlertsCorrespondence-messageRow-messageRow-dialog-text-1")}
            </p>
          ) : (
            <embed
              className="w-full h-[80%]"
              src={`data:application/pdf;base64, ${pdfSource}`}
            />
          )}
          <hr />
          <div className="block text-right mt-6">
            <button
              className="ui-btn-secondary min-w-[140px] mt-4"
              aria-label="Close window"
              onClick={() => setDialogState(false)}
            >
              {t("AlertsCorrespondence-messageRow-messageRow-dialog-button-1")}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
